import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import documentModel from "@/models/document/document";

export default function useCampaignCreateModal(props) {
  const {
    fetchDocumentContainerDetail,
    fetchDocumentContainerCreate,
    fetchDocumentContainerEdit,
  } = documentModel();
  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
  } = useValidationModal();
  const vm = getCurrentInstance().proxy;

  const loading = reactive({
      btn : false
  })

  const form = reactive({
    status: true,
    name: "",
  });

  const getDocumentCampaignDetail = () => {
    fetchDocumentContainerDetail.payload.Container_Id = props.containerId || 2;
    store
      .dispatch("api/apiRequest", fetchDocumentContainerDetail)
      .then((response) => {
        form.name = response.data.payload.name;
        form.status = response.data.payload.status == 1 ? true : false;
      });
  };

  const documentCampaignEdit = () => {
    window.$loading(true);
    loading.btn = true;
    fetchDocumentContainerEdit.payload.Container_Id = props.containerId || 2;
    fetchDocumentContainerEdit.payload.Name = form.name;
    fetchDocumentContainerEdit.payload.Status = form.status ? 1 : 2;
    store
      .dispatch("api/apiRequest", fetchDocumentContainerEdit)
      .then((response) => {
        vm.$emit("onCloseModal");
        openSuccessModal("ทำรายการสำเร็จ !");
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
        loading.btn = false;
      });
  };

  const documentCampaignCreate = () => {
    window.$loading(true);
    loading.btn = true;
    fetchDocumentContainerCreate.payload.Name = form.name;
    store
      .dispatch("api/apiRequest", fetchDocumentContainerCreate)
      .then((response) => {
        vm.$emit("onCloseModal");
        openSuccessModal("ทำรายการสำเร็จ !");
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
        loading.btn = false;
      });
  };

  const onSubmit = () => {
    return props.containerId
      ? documentCampaignEdit()
      : documentCampaignCreate();
  };

  const onModalOpen = () => {};

  onBeforeMount(() => {
    if (props.containerId) {
      getDocumentCampaignDetail();
    }
  });

  return {
    loading,
    form,
    onModalOpen,
    onSubmit,
  };
}
